var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story-maker-sticker story-maker-sticker-link-facebook",on:{"click":_vm.openEditMenu}},[_c('div',{staticClass:"link-pill"},[_c('i',{staticClass:"fa-solid fa-link"}),_c('span',[_vm._v(_vm._s(_vm.pillText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }